// React Modules
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@insight/toolkit-react'
import { t } from '@insight/toolkit-utils/lib/labels'

export const ProductNiaContainer = ({ product }) => {
  const [customerQuestion, setCustomerQuestion] = useState('')

  const submitQuestion = () => {
    const question = customerQuestion.trim()
    if (!question) return
    window.postMessage(
      {
        type: 'Nia:open',
        data: {
          question: question,
          source: 'product-details',
          productData: {
            description: product?.descriptions?.shortDescription || '',
            materialId: product?.materialId || '',
            manufacturer: product?.manufacturer?.partNumber || '',
            unspsc: product?.commodityCode || '',
            productImage: product?.primaryImage || '',
            callForPrice: product?.price?.callForPrice || false,
          },
        },
      },
      window.location.origin
    )
    setCustomerQuestion('')
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      submitQuestion()
    }
  }
  return (
    <section className="c-product-nia o-grid">
      <div className="c-product-nia__header">
        <Icon icon="NIA" />
        <div className="c-product-nia__header-text">{t("Ask Nia - Insight's AI Assistant")}</div>
      </div>
      <div className="c-product-nia__description">
        {t(
          'Have any questions about this product? Our AI assistant, Nia, will help you find the answers quickly.'
        )}
      </div>
      <div className="c-product-nia__input-container">
        <input
          className="c-input c-product-nia__input"
          id="NiaInputQuestion"
          type="text"
          placeholder={t('Type a question...')}
          onChange={(e) => setCustomerQuestion(e.target.value)}
          onKeyPress={handleKeyPress}
          value={customerQuestion}
          aria-label={t('Ask Nia a question about this product')}
        />
        <button
          className="c-product-nia__button"
          onClick={submitQuestion}
          disabled={!customerQuestion.trim()}
          aria-label={t('Submit question to Nia')}
          type="button"
        >
          <Icon icon="send" />
        </button>
      </div>
    </section>
  )
}

export default ProductNiaContainer

ProductNiaContainer.propTypes = {
  product: PropTypes.shape({
    materialId: PropTypes.string,
    manufacturer: PropTypes.shape({
      partNumber: PropTypes.string,
    }),
    commodityCode: PropTypes.string,
    descriptions: PropTypes.shape({
      shortDescription: PropTypes.string,
    }),
    primaryImage: PropTypes.string,
  }).isRequired,
}
